import { AxiosError } from "@root/libs/axios";

declare const newrelic: { noticeError: (error: Error) => void };

export const sendErrorLog = (e: Error) => {
  if (e instanceof AxiosError && e.code === AxiosError.ERR_NETWORK) return;

  if (typeof newrelic !== "undefined") {
    newrelic.noticeError(e);
  }
};
